import NotesNotifications from 'components/orders/NotesNotifications';
import ActionButton from 'components/ui/ActionButton';
import colors from 'css/colors';
import React, { useContext, useEffect, useState } from 'react';
import { Note } from './LayoutTypes';
import axios from 'axios';
import { UserContext } from '../../UserContext';

const actionButtonStyles = {
  color: colors.grey,
  '&:hover': { color: colors.white, backgroundColor: colors.black },
};

const redAlert = {
  position: 'absolute',
  bottom: -5,
  left: 27,
  color: '#fff',
  borderRadius: '50%',
  backgroundColor: ' #FF5252',
  width: 21,
  height: 21,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 10,
  border: '2px solid #fff',
} as const;

export const UserNoteIcon = () => {
  const [notesNotificationOpen, setNotesNotificationOpen] = useState(false);
  const [unreadNotes, setUnreadNotes] = useState<Note[]>([]);
  const [isVisible, setIsVisible] = useState(false);

  const { user } = useContext(UserContext) as any;

  useEffect(() => {
    let intervalId: NodeJS.Timer = null;
    if (
      [146].includes(user.id) ||
      (window.location.pathname.toLowerCase().includes('orders') &&
        !window.location.pathname.toLowerCase().includes('order-information') &&
        !window.location.pathname.toLowerCase().includes('new-order'))
    ) {
      getOrderNotes();
      intervalId = setInterval(getOrderNotes, 60000);
    } else {
      setIsVisible(false);
    }
    return () => {
      setNotesNotificationOpen(false);
      clearInterval(intervalId);
    };
  }, [window.location.pathname]);

  useEffect(() => {
    if (unreadNotes.length === 0) {
      setIsVisible(false);
      setNotesNotificationOpen(false);
    } else {
      setIsVisible(true);
    }
  }, [unreadNotes]);

  const afterMarkAllAsRead = async () => {
    await getOrderNotes();
    setNotesNotificationOpen(false);
  };
  const afterMarkOneAsRead = async () => {
    await getOrderNotes();
  };
  const getOrderNotes = async () => {
    const { data } = await axios.get(`/api/orderNote/GetUserUnreadNotes/${user.id}`);
    setUnreadNotes(data);
  };
  return (
    <span style={{ position: 'absolute', right: '10px', top: '5px', zIndex: 51 }}>
      {isVisible && (
        <ActionButton
          icon="NotificationBell"
          styles={actionButtonStyles}
          onClick={() => setNotesNotificationOpen(!notesNotificationOpen)}
        />
      )}
      {unreadNotes.length > 0 && isVisible && <div style={redAlert}>{unreadNotes.length}</div>}
      {isVisible && notesNotificationOpen && (
        <NotesNotifications
          unreadNotes={unreadNotes}
          afterMarkAllAsRead={afterMarkAllAsRead}
          isEmpty={unreadNotes.length === 0}
          afterMarkOneAsRead={afterMarkOneAsRead}
        />
      )}
    </span>
  );
};
